import { Dialog as ChakraDialog, Portal } from '@chakra-ui/react';
import { CloseButton } from './close-button';
import { forwardRef } from 'react';

interface DialogContentProps extends ChakraDialog.ContentProps {
    portalled?: boolean;
    portalRef?: React.RefObject<HTMLElement>;
    backdrop?: boolean;
    layerZIndex?: number;
}

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(function DialogContent(props, ref) {
    const { children, portalled = true, portalRef, backdrop = true, layerZIndex, ...rest } = props;

    return (
        <Portal disabled={!portalled} container={portalRef}>
            {backdrop && <ChakraDialog.Backdrop />}
            <ChakraDialog.Positioner zIndex={layerZIndex}>
                <ChakraDialog.Content bg={{ _dark: 'musa.dark.200' }} ref={ref} {...rest} asChild={false}>
                    {children}
                </ChakraDialog.Content>
            </ChakraDialog.Positioner>
        </Portal>
    );
});

export const DialogCloseTrigger = forwardRef<HTMLButtonElement, ChakraDialog.CloseTriggerProps>(function DialogCloseTrigger(
    { children, ...props },
    ref,
) {
    return (
        <ChakraDialog.CloseTrigger position="absolute" top="2" insetEnd="2" {...props} asChild>
            {children ?? <CloseButton size="sm" ref={ref} />}
        </ChakraDialog.CloseTrigger>
    );
});

export const DialogRoot = ChakraDialog.Root;
export const DialogFooter = ChakraDialog.Footer;
export const DialogHeader = ChakraDialog.Header;
export const DialogBody = ChakraDialog.Body;
export const DialogBackdrop = ChakraDialog.Backdrop;
export const DialogTitle = ChakraDialog.Title;
export const DialogDescription = ChakraDialog.Description;
export const DialogTrigger = ChakraDialog.Trigger;
export const DialogActionTrigger = ChakraDialog.ActionTrigger;
